/**
 * Copyright (c) 2018, salesforce.com, inc.
 * All rights reserved.
 * Licensed under the BSD 3-Clause license.
 * For full license text, see LICENSE.txt file in the repo root or
 * https://opensource.org/licenses/BSD-3-Clause
 */
import React from 'react';
import styled from 'styled-components';

import Localized from '../../../shared/components/Localized';

import styles from '../../styles';

const formattingString = 'HH:mm z, MMM DD';

const Wrapper = styled.div`
  border-top-right-radius: .25rem;
  border-top-left-radius: .25rem;
  padding: 1rem;
  text-align: center;

  background: #fff;
`;

const Title = styled.div`
  ${styles.fonts.headingMedium}
  margin-bottom: 0.5rem;
`;

const Description = styled.div`
  ${styles.fonts.headingSmall}
`;

class MaintenanceHeader extends React.Component {
  render() {
    const { name, serviceKeys, instanceKeys } = this.props.maintenance;

    if (serviceKeys.length) {
      return (
        <Wrapper>
          <Title>
            { name }
          </Title>
          <Description >
            { serviceKeys.map((service, index) => {
              if (index === serviceKeys.length-1) {
                return <Localized modelName={'service'} modelKey={service} modelAttribute={'label'} key={index} />;
              }

              return <span key={index} ><Localized modelName={'service'} modelKey={service} modelAttribute={'label'} />, </span>;
            })}
            <span> | </span>
            { instanceKeys.map((instance, index) => {
              if (index === instanceKeys.length-1) {
                return <Localized modelName={'instance'} modelKey={instance} modelAttribute={'label'} key={index} />;
              }

              return <span key={index} ><Localized modelName={'instance'} modelKey={instance} modelAttribute={'label'} />, </span>;
            })}
          </Description>
        </Wrapper>
      );
    }

    return (
      <Wrapper>
        <Title>
          { instanceKeys.map((instance, index) => {
            if (index === instanceKeys.length-1) {
              return <Localized modelName={'instance'} modelKey={instance} modelAttribute={'label'} key={index} />;
            }

            return <span key={index} ><Localized modelName={'instance'} modelKey={instance} modelAttribute={'label'} />, </span>;
          })}
        </Title>
      </Wrapper>
    );
  }
}

export default MaintenanceHeader;
